function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import Axios from 'axios';
import { places, excludes as excludesPath } from '../../constants/api';
import { PATH } from '../../envs/core';
const sites = {
  'www.antena3.com': 41,
  'www.lasexta.com': 7,
  'www.ondacero.es': 2
};
export const getPlace = (filter = '') => {
  return Axios.get("".concat(PATH).concat(places).concat(filter)).then(response => {
    return response.data;
  });
};
export const getChilds = (typeplace, parentId) => getPlace("typeplace=".concat(typeplace, "&parentid=").concat(parentId, "&size=1000"));
export const getExcludes = (type, numElection, year, communityId) => {
  const site = sites[window.location.hostname] || 41;
  return Axios.get("".concat(PATH).concat(excludesPath).concat(site, "/").concat(type, "/").concat(numElection, "/").concat(year, "?regionId=").concat(communityId)).then(response => {
    return response.data;
  });
};
export const empty = [];
export const PlacesProvider = ({
  type,
  parentId,
  name,
  children,
  grandParentId,
  size,
  search,
  sortby,
  excludedGrandParentIds,
  includedIds
}) => {
  const _useState = useState(null),
        _useState2 = _slicedToArray(_useState, 2),
        data = _useState2[0],
        setData = _useState2[1];

  useEffect(() => {
    const parentQuery = parentId ? "&parentid=".concat(parentId) : '';
    const grandParentQuery = grandParentId ? "&grandpaid=".concat(grandParentId) : '';
    const nameQuery = name ? "&name=".concat(name) : '';
    const searchQuery = search ? "&search=".concat(search) : '';
    const sizeQuery = "&size=".concat(size);
    const sortbyQuery = sortby ? "&sortby=".concat(sortby) : '';
    const typeQuery = type ? "typeplace=".concat(type) : '';
    const excludedQuery = excludedGrandParentIds.reduce((result, id) => result + "&excludeid=".concat(id), '');
    const includedQuery = includedIds.reduce((result, id) => result + "&addid=".concat(id), '');
    const filter = "".concat(typeQuery).concat(grandParentQuery).concat(parentQuery).concat(nameQuery).concat(sizeQuery).concat(searchQuery, "&page=0").concat(sortbyQuery).concat(excludedQuery).concat(includedQuery);
    getPlace(filter).then(response => {
      setData(response.content);
    });
  }, [type, parentId, name, grandParentId, search, sortby]);
  return children(data || empty);
};
PlacesProvider.propTypes = {
  type: PropTypes.string.isRequired,
  parentId: PropTypes.string,
  name: PropTypes.string,
  children: PropTypes.func.isRequired,
  size: PropTypes.number,
  excludedGrandParentIds: PropTypes.array,
  includedIds: PropTypes.array
};
PlacesProvider.defaultProps = {
  parentId: '',
  name: '',
  size: 1000,
  excludedGrandParentIds: [],
  includedIds: []
};